// extracted by mini-css-extract-plugin
export var bodySections = "_47-8";
export var gray = "_47-7";
export var green = "_47-4";
export var iconContainer = "_47-9";
export var iconWidgetContainer = "_47-1";
export var phoneIcon = "_47-2";
export var red = "_47-5";
export var statusDot = "_47-3";
export var widgetContainer = "_47-0";
export var yellow = "_47-6";